import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { TermsAcceptanceStorage } from './terms-acceptance-storage';
import { Injectable } from '@angular/core';
import { UrlBuilder } from '../core/url-builder/url-builder';
import { Settings } from '../core';
import { isNil } from 'lodash';
import { first } from 'rxjs/operators';

@Injectable()
export class UserAcceptedTermsGuard implements CanActivate {

    constructor(
        private termsAcceptanceStorage: TermsAcceptanceStorage,
        private settings: Settings,
        private urlBuilder: UrlBuilder) {
    }

    public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const termsAccepted = await this.termsAcceptanceStorage.areTermsAccepted
            .pipe(first())
            .toPromise();

        if (!termsAccepted && isNil(this.settings.emulatedUserId)) {
            console.debug('Terms of usage were not accepted, redirecting...');
            this.urlBuilder.esa().terms().navigate({ saveReturnUrl: true });
            return false;
        }

        return true;
    }
}